import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f982c60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-detail-card" }
const _hoisted_2 = { class: "user-detail-card__header" }
const _hoisted_3 = { class: "user-detail-card__date" }
const _hoisted_4 = { class: "user-detail-card__percent" }
const _hoisted_5 = { class: "user-detail-card__number" }

import { PropType } from 'vue'
import { AdminReportType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  report: Object as PropType<AdminReportType>,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.report.date), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.report.percentage) + "%", 1)
    ]),
    _createElementVNode("p", _hoisted_5, " №" + _toDisplayString(__props.report.id) + "  ·  ID пациента: " + _toDisplayString(__props.report.patient), 1)
  ]))
}
}

})